/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Compare_SubtitleInputs */

const en_home_compare_subtitle = /** @type {(inputs: Home_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AutoCAD remains the industry standard. CADCraft is a free, open alternative for 2D drafting, automation and AI workflows. Choose CADCraft when cost, Linux support, browser access or agent automation matter most. Stay with AutoCAD when you need full DWG fidelity, 3D modeling, industry toolsets or vendor support.`)
};

/**
* | output |
* | --- |
* | "AutoCAD remains the industry standard. CADCraft is a free, open alternative for 2D drafting, automation and AI workflows. Choose CADCraft when cost, Linux su..." |
*
* @param {Home_Compare_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_compare_subtitle = /** @type {((inputs?: Home_Compare_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Compare_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_compare_subtitle(inputs)
});
export { home_compare_subtitle as "home.compare.subtitle" }